<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Product" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-product-form [product]="product" *ngIf="product"></app-product-form>
        </form>
      </div>
    </section>
  </div>
</div>
